<template>
  <div style="text-align:center;">
    <el-table
      :data="tableData_"
      row-key="id"
      default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="resourceName" header-align="center" label="权限" align="left"></el-table-column>
      <el-table-column prop="description" header-align="center" align="left" label="说明"></el-table-column>
      <el-table-column width="200" align="center" label="权限控制">
        <template slot-scope="scope">
          <!-- 开关 v-model 绑定值，active-value 是判断v-model绑定的值等于active-value的值时则开，反则关-->
          <el-switch
            v-if="scope.row.displayType === '0' || scope.row.displayType === 0"
            v-model="scope.row.value"
            active-value="true"
            inactive-value="false"
            @change="change(scope.row,$event)"
          ></el-switch>
          <!-- 下拉框 v-model 赋值-->
          <el-select
            v-if="scope.row.displayType === '1' || scope.row.displayType === 1"
            v-model="scope.row.value"
            placeholder="请选择"
            @change="noticeChangeData"
            size="small"
          >
            <el-option
              v-for="item in formatStr(scope.row.data)"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <!--自定义组件 -->
          <div v-if="scope.row.displayType === '2' || scope.row.displayType === 2">
            <el-select
              v-model="scope.row.value.option"
              placeholder="请选择"
              @change="changeSelect($event,scope.row.value,scope.row.id)"
              size="small"
            >
              <el-option
                v-for="item in formatStr(scope.row.data)"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-link
              :ref="`alink${scope.row.id}`"
              v-if="showLink(scope.row.value.option)"
              @click="changeSelect('zdykz',scope.row.value,scope.row.id)"
              type="primary"
            >
              已选择
              {{calcCurCount(scope.row.value)}}
              组，点击查看
            </el-link>
          </div>
          <!--跨技能组-->
          <el-select
            v-if="showSelect(scope)"
            v-model="scope.row.value"
            multiple
            collapse-tags
            placeholder="请选择"
            @change="noticeChangeData"
            size="small"
          >
            <el-option
              v-for="item in skillGroupData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      width="280px"
      :destroy-on-close="true"
      :visible.sync="dialogShow"
      v-if="dialogShow"
      title="自定义跨组"
      :show-close="false"
      class="customgroup-dialog"
    >
      <AcrossGroup
      :cancel="cancelDialogFn"
      :confirm="confirmDialogFn"
      :selectedData="selectedData"
      >
      </AcrossGroup>
    </el-dialog>
  </div>
</template>

<script>
import AcrossGroup from '@/views/auth/rolemgr/components/AcrossGroup'
export default {
  name: 'RoleTable',
  data() {
    return {
      dialogShow: false,
      selectedData: {
        selectedTableData: [],
        selectedTreeData: []
      },
      curItemId: ''
    }
  },
  mounted() {
  },
  props: {
    tableData: Array,
    storeType: String,
    appId: String
  },
  watch: {
  },
  components: {
    AcrossGroup
  },
  computed: {
    skillGroupData() {
      return this.$store.state.role.skillGroupData
    },
    userGroupData() {
      return this.$store.state.user.userGroupTree
    },
    tableData_() {
      const data = JSON.parse(JSON.stringify(this.tableData))
      this.fixData(data)
      return data
    }
  },
  methods: {
    noticeChangeData() {
      // 系统权限和坐席工作台权限
      if (this.storeType === 'setCurAddSysAuthData' || this.storeType === 'setCurAddWbAuthData') {
        this.$store.commit(`role/${this.storeType}`, this.tableData_)
      } else {
        const data = {}
        data.appId = this.appId
        data.data = this.tableData_
        this.$store.commit(`role/${this.storeType}`, data)
      }
    },
    fixData(data) {
      if (data && data.length > 0) {
        for (const i of data) {
          /** 跨组数据修正 */
          if (i.displayType === '2') {
            if (!i.value) {
              i.value = {}
              i.value.option = null
              i.value.detail = null
            }
            if (i.value.detail) {
              if (i.value.detail.jnzData) {
                i.value.detail.jnzData = this.fixSkillGroupData(i.value.detail.jnzData)
              }
              if (i.value.detail.zxzData) {
                i.value.detail.zxzData = this.fixUserGroupData(i.value.detail.zxzData, this.userGroupData)
              }
            }
          }
          /** 技能组数据修正 */
          if (i.displayType === '3' && i.value && i.value.length > 0) {
            const nl = []
            for (const item of i.value) {
              for (const group of this.skillGroupData) {
                if (item === group.id) {
                  nl.push(item)
                }
              }
            }
            i.value = nl
          }
          if (i.children && i.children.length > 0) {
            this.fixData(i.children)
          }
        }
      }
    },
    fixSkillGroupData(data) {
      const nl = []
      for (const item of data) {
        for (const group of this.skillGroupData) {
          if (item.id === group.id) {
            item.name = group.name
            nl.push(item)
          }
        }
      }
      return nl
    },
    fixUserGroupData(data, userGroupData) {
      let nl = []
      for (const group of userGroupData) {
        for (const item of data) {
          if (item.id === group.id) {
            item.name = group.name
            nl.push(item)
          }
        }
        if (group.children && group.children.length > 0) {
          nl = nl.concat(this.fixUserGroupData(data, group.children))
        }
      }
      return nl
    },

    calcCurCount(crossGroup) {
      let count = 0
      if (crossGroup.detail && crossGroup.detail.jnzData) {
        count += crossGroup.detail.jnzData.length
      }
      if (crossGroup.detail && crossGroup.detail.zxzData) {
        count += crossGroup.detail.zxzData.length
      }
      return count
    },
    cancelDialogFn() {
      this.dialogShow = false
    },
    confirmDialogFn(selectedData) {
      this.$refs[`alink${this.curItemId}`].$el.innerText =
        '已选择' +
        (selectedData.selectedTableData.length + selectedData.selectedTreeData.length) +
        '组，点击查看'
      this.selectedData = selectedData
      // 递归查找树节点，并改变数据
      const findNode = function (arr, key) {
        arr.forEach(child => {
          if (child.id === key) {
            child.value.detail = {}
            child.value.detail.jnzData = selectedData.selectedTableData
            child.value.detail.zxzData = selectedData.selectedTreeData
            return true
          } else if (child.children && child.children.length > 0) {
            return findNode(child.children, key)
          }
        })
      }
      findNode(this.tableData_, this.curItemId)
      this.dialogShow = false
    },
    showLink(val) {
      return val === 'zdykz' || val === 'zdyzxz' || val === 'zdyjnz'
    },
    // 下拉框的改变，调整dialog
    changeSelect(value, crossGroup, id) {
      if (value === 'zdykz' || value === 'zdyzxz' || value === 'zdyjnz') {
        this.curItemId = id
        if (crossGroup.detail && crossGroup.detail.jnzData) {
          this.selectedData.selectedTableData = crossGroup.detail.jnzData
        } else {
          this.selectedData.selectedTableData = []
        }
        if (crossGroup.detail && crossGroup.detail.zxzData) {
          this.selectedData.selectedTreeData = crossGroup.detail.zxzData
        } else {
          this.selectedData.selectedTreeData = []
        }
        // 放最后
        this.dialogShow = true
      } else {
        crossGroup.detail = {}
      }
      this.noticeChangeData()
    },
    showAcrossGroup() {

    },
    // 开关的改变
    change(node, checked) {
      this.handleCheckAllChange(node, checked)
      this.noticeChangeData()
    },
    formatStr(value) {
      return this._evil(value)
    },
    /**
     * 字符串转json，javascript原生evil
     */
    _evil(fn) {
      var Fn = Function
      return new Fn('return ' + fn)()
    },
    /**
     * 子父级关联开关
     */
    handleCheckAllChange(node, checked) {
      // 有下级去处理下级
      if (node.children && node.children.length > 0) {
        this.findChildren(node.children, checked)
      }
      // 处理上级
      if (this.storeType === 'setCurAddWbAuthData') {
        if (node.parentId) {
          this.findParent(this.tableData_, node.parentId, checked)
        }
      } else if (checked === 'true') { // 2020年4月24日14:36:13 关闭子级时，父级不需要联动关闭
        if (node.parentId) {
          this.findParent(this.tableData_, node.parentId, checked)
        }
      }
    },
    findChildren(list, checked) {
      list.forEach(child => {
        if (child.displayType === '0') {
          // 开关
          child.value = checked
        } else {
          if (checked === 'true') {
            child.value.option = JSON.parse(child.data)[0].value
          } else {
            child.value.option = ''
          }
        }
        if (child.children && child.children.length > 0) {
          this.findChildren(child.children, checked)
        }
      })
    },
    /**
     * TODO 处理非开关类计算  控制子父级的开关
     * 目前只计算了开关形式的按钮
     */
    findParent(list, parentId, checked) {
      list.forEach(result => {
        let childUnCheckedLength = 0
        if (result.id === parentId) {
          result.children.forEach(children => {
            if (children.value === 'false') {
              childUnCheckedLength++
            }
          })
          if (checked === 'true') {
            result.value = checked.toString()
          } else {
            // 关，子节点全部关，则父节点关
            if (result.value === 'true') {
              if (childUnCheckedLength === result.children.length) {
                // 全关
                result.value = 'false'
              }
            }
          }
          if (result.parentId) {
            this.findParent(this.tableData_, result.parentId, checked)
          }
        } else if (result.children && result.children.length > 0) {
          this.findParent(result.children, parentId, checked)
        }
      })
    },
    showSelect(scope) {
      if (scope.row.displayType === '3' || scope.row.displayType === 3) {
        if (typeof (scope.row.value) === 'string') {
          scope.row.value = scope.row.value.split(',')
        }
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-link {
  font-size: 12px;
}
  .el-table {
    ::v-deep .el-table__header-wrapper {
      .el-table__header {
        width: 100% !important;
      }
    }
    ::v-deep .el-table__body-wrapper {
      .el-table__body {
        width: 100% !important;
      }
    }
  }
</style>
<style lang="scss">
.customgroup-dialog {
  .el-dialog {
    .el-dialog__header {
      padding: 0 20px 0px;
    }

    .el-dialog__body {
      padding: 0 10px 10px;
      .el-main {
        padding: 0;
        font-size: 12px;
        .modal-subtitle {
          height: 30px;
          line-height: 30px;
        }

        .el-tabs__header {
          margin-bottom: 0;

          .el-tabs__nav {
            width: 100%;
            border: none;

            .el-tabs__item {
              width: 50%;
              height: 28px;
              line-height: 28px;
            }
          }
        }

        .el-tabs__content {
          .el-tab-pane {
            height: 140px;
            overflow: auto;
            border-left: 1px solid #e1e3e6;
            border-right: 1px solid #e1e3e6;

            .el-table__body-wrapper {
              overflow: auto;

              .el-button {
                border-top: none;
              }
            }
          }
        }

        .el-button {
          width: 100%;
          border-radius: 0;
          border: 1px solid #e1e3e6;

          & + .el-button {
            border-left: none;
          }

          &.el-button--primary {
            border: 1px solid #64b0f7;
          }

          .icon {
            color: #818990;
          }
        }
      }
    }
  }
}
</style>
